export const RoomLinkIcn = () => (
  <svg
    width="21"
    height="20"
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.20289 5.22018C8.92121 5.10432 10.8027 5.19237 11.4701 5.91534L14.4593 2.99569C15.9886 2.09198 18.1436 3.55181 17.3094 5.35921L12.3043 10.5034C11.9335 10.6887 10.9272 11.0624 10.2883 10.5034L9.73221 10.0168C8.68949 9.59966 7.43819 10.2948 7.85529 11.7546C9.24559 13.145 10.4737 13.423 11.4701 13.423C12.4665 13.423 13.6413 13.1466 14.3203 12.4498C16.9618 9.7387 16.9097 9.79083 16.8576 9.84296C16.8054 9.89509 16.7533 9.94723 19.3949 7.23612C20.4109 6.19339 20.5766 2.99569 18.5607 1.11877C16.5387 -0.763844 13.347 0.0760305 12.3043 1.11877L8.20289 5.22018ZM11.9259 14.3267C11.2076 14.4426 9.32607 14.3545 8.65872 13.6316L5.66956 16.5512C4.14022 17.4549 1.98524 15.9951 2.81942 14.1877L7.82454 9.04353C8.19529 8.85816 9.20164 8.48454 9.84049 9.04353L10.3966 9.53014C11.4393 9.94724 12.6906 9.25208 12.2735 7.79225C10.8832 6.40195 9.65511 6.12388 8.65873 6.12388C7.66234 6.12388 6.48748 6.40033 5.80857 7.0971C3.16698 9.80821 3.21913 9.75607 3.27127 9.70394C3.32341 9.6518 3.37555 9.59968 0.733967 12.3108C-0.28203 13.3535 -0.447797 16.5512 1.56812 18.4281C3.59016 20.3107 6.78181 19.4709 7.82454 18.4281L11.9259 14.3267Z"
      fill="#00a799"
    />
  </svg>
);
